import React from 'react';
import { Link } from 'react-router-dom';
import { Button, DisableIcon, Icon, ShareIcon, Text, Tooltip } from 'evergreen-ui';
import { useSourceInfoButtonStyles } from './useStyles';

export const SourceInfoButton = ({ sourceName, sourcePath }: {
  sourceName: string;
  sourcePath: string | null;
}) => {
  const classes = useSourceInfoButtonStyles();
  const infoPath = `${sourcePath}/profile/info`;
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
  };

  if (sourcePath === null) {
    return (
      <Button
        appearance="minimal"
        onClick={handleClick}
        className={classes.button}
      >
        <Tooltip content="Объект не существует или был удален">
          <Icon
            icon={DisableIcon}
            color="muted"
            size={14}
          />
        </Tooltip>
        <Text className={classes.text}>
          {`${sourceName} Объект не найден`}
        </Text>
      </Button>
    );
  }

  return (
    <Link
      to={infoPath}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.link}
    >
      <Button
        appearance="minimal"
        onClick={handleClick}
        className={classes.button}
      >
        <Tooltip content="Открыть в новой вкладке">
          <Icon
            icon={ShareIcon}
            color="muted"
            size={14}
          />
        </Tooltip>
        <Text className={classes.text}>
          {sourceName}
        </Text>
      </Button>
    </Link>
  );
};
